import { render, staticRenderFns } from "./FirmGroupDetails.vue?vue&type=template&id=c7544d72"
import script from "./FirmGroupDetails.vue?vue&type=script&lang=js"
export * from "./FirmGroupDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports